import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs, Divider } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import ShapeDrawForm from '../components/ShapeDrawForm';
import ShapesMap from '../components/ShapesMap';
import { Map, TileLayer, GeoJSON } from 'react-leaflet';


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class Shapes_Tabs extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    licence_shapes: [],
    datarequested:true,

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/licence_shapes/?licence=${this.props.licence_id}`)
  .then(response => {

    const features = response.data.features.map(feature => {
      const wktGeometry = feature.geometry.split(';')[1]; // Exclude 'SRID=4326;'
      const coordinates =this. wktToGeoJSON(wktGeometry); // Convert WKT to GeoJSON
        return {
            ...feature,
            geometry: {
                type: "Polygon",
                coordinates: coordinates
            }
        };
    });

    this.setState({licence_shapes:features});

    this.setState({datarequested:false})

  })


  console.log("licence_id: "+this.props.licence_id)



}


   // Convert WKT string to GeoJSON
    wktToGeoJSON = (wkt) => {
    const coordinates = wkt
        .replace(/POLYGON \(\(/, '')
        .replace(/\)\)$/, '')
        .split(', ')
        .map(coord => coord.split(' ').map(Number));
    return [coordinates]; // Nested as per GeoJSON specification for Polygon
};



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {

    const columns = [
    
      {
        title: 'Name',
        dataIndex: 'legal_description',
        key: 'id',
        ...this.getColumnSearchProps('name'),
      },
    ];


    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
              <TabPane tab="New Shape" key="1">
                <ShapeDrawForm licence_id={this.props.licence_id} />
              </TabPane>

              <TabPane tab={"Shapes ("+this.state.licence_shapes.length+")"} key="2">
                 <ShapesMap licence_id={this.props.licence_id} />
              </TabPane>
            
             </Tabs>

        </div>
    )

    }

   
  }
}

export default Shapes_Tabs; 
